// Els textos del mòdul, en català. Mateixes claus que es.js, exactament.

export default {
  markets: {
    title: 'Mercats',

    actions: {
      save: 'Desar',
      saved: 'Desat',
      cancel: 'Cancel·lar',
      edit: 'Editar',
      remove: 'Treure',
    },

    units: {
      points: 'p.',
    },

    windows: {
      day: 'Un dia',
      week: 'Una setmana',
      month: '30 dies',
      year: 'Un any',
    },

    home: {
      title: 'Mercats',
      subtitle: 'Què està canviant fora i quant us costa',
      prepareMeeting: 'Preparar reunió',
      risks: 'Riscos oberts',
      opportunities: 'Oportunitats',
      watched: 'Factors vigilats',
      newReports: 'Informes nous',
      exposure: 'Compra exposada',
      costAtRisk: 'Sobrecost anual',
      whatChanged: 'Què ha canviat',
      summarise: 'Resumir amb IA',
      summaryUnavailable: 'El resum no està disponible ara mateix. Els canvis de sota són els mateixos.',
      nothingChanged: 'No s\'ha mogut res',
      nothingChangedHint: 'Cap factor vigilat ha creuat el seu llindar des de l\'última vegada que hi vas entrar.',
      references: '{count} referències',
      radar: 'El que més es mou',
      radarQuiet: 'Cap factor vigilat està fora del normal.',
      unlinked: '{count} indicadors no estan lligats a res vostre: d\'aquests no en surt cap xifra en euros.',
      stale: '{count} indicadors fa temps que no s\'actualitzen.',
      toDo: 'Pendent d\'algú',
      sourcesDue: 'Fonts per revisar',
      decisionsDue: 'Decisions per valorar',
      overdue: '{count} dies de retard',
      nothingToDo: 'No hi ha res pendent.',
      reports: 'Informes recents',
      kind: {
        impact: 'Impacte',
        indicator: 'Indicador',
        report: 'Informe',
      },
    },

    coverage: {
      title: 'Encara no hi ha dades internes',
      body: 'Aquest mòdul creua el que passa fora amb el vostre consum, les vostres compres i els vostres costos. Sense Magatzem ni Compres instal·lats no hi ha amb què creuar-ho.',
      hint: 'El de fora —temes, fonts, informes i indicadors— funciona igual des d\'avui.',
    },

    radar: {
      title: 'Radar',
      subtitle: 'Tot el que vigileu, amb el seu color',
      recompute: 'Recalcular ara',
      recomputed: 'Recalculat: {count} impactes',
      colFactor: 'Factor',
      colValue: 'Valor',
      colChange: 'Variació',
      colStatus: 'Estat',
      colCost: 'Cost anual',
      noLinks: 'Sense enllaçar',
      notUpdated: 'Sense actualitzar',
      unlinked: '{count} sense enllaçar amb res vostre',
      stale: '{count} sense actualitzar',
      empty: 'El radar és buit',
      emptyHint: 'Dona d\'alta un indicador i enganxa\'n la sèrie perquè comenci a vigilar-se.',
    },

    status: {
      favourable: 'Favorable',
      neutral: 'Normal',
      watch: 'Atenció',
      risk: 'Risc',
      critical: 'Crític',
      unknown: 'Sense dades',
      up: 'Puja',
      down: 'Baixa',
      flat: 'Estable',
    },

    severity: {
      info: 'Informació',
      watch: 'Atenció',
      high: 'Important',
      critical: 'Crític',
    },

    direction: {
      risk: 'Risc',
      opportunity: 'Oportunitat',
      both: 'Riscos i oportunitats',
    },

    trend: {
      up: 'A l\'alça',
      down: 'A la baixa',
      flat: 'Estable',
      unknown: 'Sèrie insuficient',
    },

    kinds: {
      commodity: 'Matèries primeres',
      energy: 'Energia',
      logistics: 'Transport i logística',
      industry: 'Activitat industrial',
      construction: 'Construcció',
      economy: 'Economia',
      fx: 'Divises',
      labour: 'Mà d\'obra',
      sector: 'Sector',
    },

    valueTypes: {
      price: 'Preu',
      index: 'Índex',
      rate: 'Taxa o percentatge',
      quantity: 'Quantitat',
    },

    badDirection: {
      up: 'Que pugi ens perjudica',
      down: 'Que baixi ens perjudica',
      none: 'Cap direcció ens perjudica',
    },

    origins: {
      manual: 'A mà',
      import: 'Enganxat',
      report: 'D\'un informe',
      feed: 'Automàtic',
    },

    horizons: {
      short: 'Curt termini',
      medium: 'Mitjà termini',
      long: 'Llarg termini',
      unknown: 'Sense termini',
    },

    importance: {
      1: 'Baixa',
      2: 'Mitjana',
      3: 'Alta',
    },

    strength: {
      none: 'cap',
      weak: 'feble',
      moderate: 'moderada',
      strong: 'forta',
    },

    confidence: {
      high: 'Confiança alta',
      medium: 'Confiança mitjana',
      low: 'Confiança baixa',
      short: 'Confiança {score}',
    },

    metrics: {
      revenue: 'Facturació',
      order_intake: 'Feina guanyada',
      offers_out: 'Pressupostat',
      purchase_spend: 'Compra rebuda',
      material_cost: 'Material consumit',
    },

    tiers: {
      A: 'Organisme oficial: INE, Eurostat, BCE, Comissió Europea',
      B: 'Associació sectorial o consultora reconeguda',
      C: 'Premsa especialitzada',
      D: 'Sense verificar',
    },

    sourceKinds: {
      website: 'Pàgina web',
      rss: 'RSS',
      pdf: 'PDF',
      report: 'Informe',
      api: 'API',
      spreadsheet: 'Full de càlcul',
      newsletter: 'Butlletí',
      association: 'Associació sectorial',
      public_body: 'Organisme públic',
      supplier: 'Proveïdor',
      institute: 'Institut econòmic',
      bank: 'Banc',
      consultancy: 'Consultora',
      manual: 'A mà',
    },

    indicators: {
      title: 'Indicadors',
      subtitle: 'El que vigileu de fora, amb la seva sèrie',
      new: 'Nou indicador',
      edit: 'Editar indicador',
      searchPlaceholder: 'Nom o clau…',
      allKinds: 'Totes les categories',
      colName: 'Indicador',
      colValue: 'Últim valor',
      colMonth: '30 dies',
      colYear: 'Un any',
      colLinks: 'Enllaçat',
      linked: '{count} enllaços',
      unlinked: 'Sense enllaçar',
      empty: 'Encara no hi ha indicadors',
      emptyCommodities: 'Encara no hi ha matèries primeres',
      emptyHint: 'Dona d\'alta el primer i enganxa la seva sèrie de preus; a partir d\'aquí en surt tota la resta.',
      name: 'Nom',
      namePlaceholder: 'Acer laminat (Europa)',
      kind: 'Categoria',
      valueType: 'Què és el valor',
      valueTypeHint: 'Un preu es llegeix en percentatge; una taxa com l\'IPC es llegeix en punts.',
      unit: 'Unitat',
      unitHint: 'El que va darrere del número.',
      unitPlaceholder: 'EUR/kg',
      source: 'Font',
      noSource: 'Sense font',
      badDirection: 'Quina direcció us perjudica',
      badDirectionHint: 'Que l\'acer pugi perjudica qui fabrica; que l\'electricitat baixi el beneficia. Sense això, el radar acoloreix al revés.',
      watchThreshold: 'Llindar d\'atenció (%)',
      alertThreshold: 'Llindar de risc (%)',
      thresholdHint: 'En 30 dies. Buit fa servir el del mòdul.',
      default: 'Per defecte',
      description: 'Descripció',
    },

    commodities: {
      title: 'Matèries primeres',
      subtitle: 'El que compreu i quant es mou el seu preu',
    },

    indicator: {
      subtitle: '{kind} · actualitzat {updated}',
      current: 'Ara',
      trend: 'Tendència',
      series: 'Sèrie',
      from: '{source} · nivell {tier}',
      noSeries: 'Encara no hi ha prou lectures per dibuixar res.',
      addReading: 'Afegir lectura',
      links: 'Enllaços',
      simulate: 'Simular',
      linkedTo: 'A què afecta',
      noLinks: 'No està lligat a res vostre',
      noLinksHint: 'Sense enllaços aquest indicador és informació, no euros. Lliga-hi les referències que en depenen.',
      readings: 'Lectures',
      noReadings: 'Encara no hi ha lectures',
      noReadingsHint: 'Afegeix-ne una a mà o enganxa la sèrie sencera des d\'un full de càlcul.',
      colDate: 'Data',
      colValue: 'Valor',
      colOrigin: 'D\'on ha sortit',
      fromReport: 'Veure l\'informe',
      removeReading: 'Treure aquesta lectura?',
      removeReadingHint: 'La sèrie es recalcula sense ella. En queda constància a auditoria.',
    },

    points: {
      title: 'Lectures de {name}',
      tabOne: 'Una lectura',
      tabMany: 'Enganxar una sèrie',
      date: 'Data',
      value: 'Valor {unit}',
      valuePlaceholder: '1,29',
      note: 'Nota',
      noteHint: 'D\'on surt aquesta xifra en concret, si no és la font de sempre.',
      save: 'Desar lectura',
      saved: 'Lectura desada',
      paste: 'Enganxa dues columnes: data i valor',
      pasteHint: 'Tal com surtin del full de càlcul o del web. Entén comes i punts decimals, i dates en els dos formats.',
      pastePlaceholder: '01/01/2026;1,18\n01/02/2026;1,21',
      import: 'Importar',
      imported: '{count} lectures desades',
      rejected: '{count} línies no s\'han pogut llegir',
      line: 'Línia {line}',
      reason: {
        columns: 'no té dues columnes',
        date: 'la data no s\'entén',
        value: 'el valor no s\'entén',
      },
    },

    links: {
      title: 'Enllaços de {name}',
      lead: 'Un enllaç diu quina part del cost d\'una referència explica aquest indicador. Sense enllaços no hi ha cap xifra en euros.',
      tabCurrent: 'Actuals',
      tabAdd: 'Afegir',
      tabSuggest: 'Proposar amb IA',
      none: 'Encara no hi ha enllaços',
      noneHint: 'Lliga aquest indicador a les referències o famílies que en depenen.',
      colTarget: 'A què afecta',
      colWeight: 'Pes',
      colOrigin: 'Estat',
      colReason: 'Per què',
      confirmed: 'Confirmat',
      proposed: 'Proposat',
      confirm: 'Confirmar',
      remove: 'Treure',
      what: 'Què s\'enllaça',
      material: 'Referència',
      materialPlaceholder: 'Busca per nom o codi…',
      category: 'Família',
      metric: 'Xifra interna',
      metricHint: 'Per comparar el mercat amb la vostra pròpia evolució.',
      supplierId: 'Identificador del proveïdor',
      supplierHint: 'Per poder comparar aquell proveïdor amb aquest índex.',
      weight: 'Pes (0 a 1)',
      weightHint: 'Quant del cost d\'aquella referència explica aquest indicador. Un perfil d\'acer, 0,9; una vàlvula acabada, 0,3.',
      add: 'Afegir enllaç',
      suggestLead: 'La IA proposa; ningú no escriu res fins que tu ho acceptes. El que s\'accepta queda sense confirmar fins que ho repasses un a un.',
      searchPlaceholder: 'Acota el catàleg: acer, tub, perfil…',
      suggest: 'Proposar',
      suggestUnavailable: 'Les propostes no estan disponibles en aquesta instància. Els enllaços es poden afegir a mà igualment.',
      acceptNote: 'El que acceptis es desa com a proposta. L\'exposició dirà quants enllaços continuen sense confirmar.',
      accept: 'Acceptar {count}',
      accepted: '{count} enllaços creats',
      target: {
        material: 'Referència',
        category: 'Família',
        metric: 'Xifra interna',
        supplier: 'Proveïdor',
      },
    },

    impacts: {
      title: 'Impactes',
      subtitle: 'El que s\'ha mogut fora, mesurat contra el vostre',
      recompute: 'Recalcular',
      recomputed: 'Recalculat: {count} impactes',
      status: 'Estat',
      direction: 'Sentit',
      risks: 'Riscos',
      opportunities: 'Oportunitats',
      exposure: 'Compra exposada',
      costAtRisk: 'Sobrecost anual',
      savings: 'Estalvi anual',
      colWhat: 'Què s\'ha mogut',
      colChange: 'Variació',
      colCost: 'A l\'any',
      colReferences: 'Referències',
      colSeverity: 'Gravetat',
      colConfidence: 'Confiança',
      overDays: 'en {count} dies',
      empty: 'No hi ha impactes oberts',
      emptyHint: 'Res del que vigileu s\'ha mogut prou per costar diners.',
    },

    impactStatus: {
      open: 'Oberts',
      reviewed: 'Revisats',
      decided: 'Decidits',
      dismissed: 'Descartats',
      expired: 'S\'han desfet',
      all: 'Tots',
    },

    impact: {
      subtitle: '{change} en {days} dies',
      explain: 'Explicar amb IA',
      explainUnavailable: 'L\'explicació no està disponible ara mateix. Les xifres de dalt no canvien.',
      dismiss: 'Descartar',
      dismissConfirm: 'Descartar aquest impacte?',
      dismissConfirmHint: 'Deixa de comptar al tauler. La xifra i el seu rastre es queden per si algú ho pregunta.',
      decide: 'Registrar decisió',
      references: 'Referències darrere de la xifra',
      colReference: 'Referència',
      colShare: 'Pes',
      colSpend: 'Compra anual',
      colDelta: 'Diferència',
      decisions: 'Decisions preses',
      evidence: 'D\'on surt això',
      state: 'Estat',
      status: 'Situació',
      raised: 'Detectat',
      reviewed: 'Revisat',
      dismissReason: 'Motiu',
      openIndicator: 'Veure l\'indicador',
    },

    insight: {
      what: 'Què ha passat',
      why: 'Per què importa',
      action: 'Què es pot fer',
      overDays: 'en {count} dies',
      touches: 'Afecta {count} referències vostres',
      suppliers: '· {count} proveïdors',
      exposure: 'Compra anual exposada',
      annualCost: 'Efecte sobre l\'any',
    },

    evidence: {
      lead: 'Cada xifra que sosté aquesta conclusió, i on mirar-la.',
      open: 'Veure',
      none: 'No es va desar el rastre d\'aquest càlcul.',
      days: '{count} dies',
      move: 'Moviment de l\'indicador',
      materials: 'Referències afectades',
      annualSpend: 'Compra anual exposada',
      window: 'Finestra mesurada',
      confidence: 'Confiança del càlcul',
      source: 'Font de la dada',
      unconfirmed: 'Enllaços sense confirmar',
      noData: 'Referències sense consum ni compres',
    },

    simulate: {
      title: 'Simular {name}',
      lead: 'No desa res. És una pregunta, i les preguntes no van a la llista d\'impactes.',
      custom: 'Un altre percentatge',
      verdict: 'Si {name} {change}, l\'any costaria {amount} {direction}.',
      more: 'més',
      less: 'menys',
      exposure: 'Compra anual exposada',
      annualCost: 'Efecte sobre l\'any',
      references: 'Referències afectades',
      projected: 'Preu resultant',
      unconfirmed: '{count} enllaços sense confirmar',
      noData: '{count} referències sense consum ni compres',
      colReference: 'Referència',
      colShare: 'Pes',
      colSpend: 'Compra anual',
      colDelta: 'Diferència',
      suppliers: 'Amb qui és la conversa',
      noLinks: 'Aquest indicador no està lligat a cap referència vostra.',
      noLinksHint: 'Sense enllaços no hi ha res a multiplicar. La resposta és un enllaç, no un número més gran.',
      close: 'Tancar',
    },

    compare: {
      title: 'Mercat i empresa',
      subtitle: 'El que fa el sector, al costat del que feu vosaltres',
      market: 'Mercat',
      company: 'Empresa',
      chart: 'Veure',
      notLinked: 'Sense xifra interna associada',
      link: 'Associar',
      empty: 'Encara no hi ha res a comparar',
      emptyHint: 'Lliga un indicador a una de les vostres xifres internes des de la seva fitxa.',
      noInside: 'Encara no hi ha xifres internes',
      noInsideBody: 'La columna de la dreta s\'omple amb el que expliquen Facturació, Pressupostos i Compres. Sense aquests mòduls no hi ha amb què comparar.',
      pairTitle: '{indicator} i {metric}',
      correlation: 'Correlació {strength} (r = {r}).',
      lag: 'El desfasament que més la reforça és de {months} mesos.',
      notCausation: 'Que dues sèries es moguin juntes no vol dir que una causi l\'altra.',
      tooFew: 'Només hi ha {count} mesos comparables; en calen {min} perquè la xifra signifiqui alguna cosa.',
      noCorrelation: 'No hi ha prou mesos en comú per calcular res.',
    },

    suppliers: {
      title: 'Proveïdors i mercat',
      subtitle: 'Com s\'ha mogut el que pagueu de veritat',
      method: 'Compara el preu mitjà ponderat de cada referència en les dues meitats dels últims {days} dies.',
      window90: 'Tres mesos',
      window180: 'Sis mesos',
      window365: 'Un any',
      window730: 'Dos anys',
      colSupplier: 'Proveïdor i referència',
      colBefore: 'Primera meitat',
      colAfter: 'Segona meitat',
      colChange: 'Variació',
      colSpend: 'Compra',
      tooFew: 'Una sola compra',
      empty: 'Encara no hi ha compres per comparar',
      emptyHint: 'Cada comanda de compra rebuda hi afegeix línies.',
      noPurchasing: 'Compres no està instal·lat',
      noPurchasingBody: 'Aquestes xifres surten de les comandes de compra rebudes. Sense aquell mòdul no hi arriba cap línia.',
      caveat: 'Només hi entren línies de comandes rebudes. Una referència comprada una sola vegada dins la finestra no té percentatge, i això no és el mateix que haver mantingut preus.',
    },

    reports: {
      title: 'Informes',
      subtitle: 'El que publica el sector, llegit i comparable',
      file: 'Arxivar informe',
      filed: 'Informe arxivat',
      searchPlaceholder: 'Títol o font…',
      allReports: 'Tots',
      onlyRead: 'Només els llegits',
      onlyUnread: 'Només els pendents',
      colTitle: 'Informe',
      colTier: 'Nivell',
      colDate: 'Data',
      colFindings: 'Què se\'n va treure',
      colConfidence: 'Confiança',
      figures: '{count} xifres',
      risks: '{count} riscos',
      opportunities: '{count} oportunitats',
      notRead: 'Sense llegir',
      duplicate: 'Repetit',
      confirmations: 'confirmat per {count}',
      empty: 'Encara no hi ha informes',
      emptyHint: 'Puja el primer PDF, o enganxa el text d\'un butlletí.',
      title2: 'Títol',
      titlePlaceholder: 'Informe de la indústria espanyola 2027',
      source: 'Font',
      noSource: 'Sense font',
      publishedAt: 'Data de publicació',
      publishedAtHint: 'La del document, no la d\'avui.',
      document: 'Document',
      documentHint: 'PDF o fotografia. Fins a 25 MB.',
      orPaste: 'O enganxa el text',
      orPasteHint: 'Per a un butlletí o una pàgina web que no es pot adjuntar.',
      save: 'Arxivar',
      analyseLater: 'Arxivar no el llegeix. La lectura amb IA es demana després, des de la fitxa de l\'informe.',
    },

    report: {
      openFile: 'Obrir el document',
      read: 'Llegir amb IA',
      reread: 'Tornar a llegir',
      readDone: 'Informe llegit',
      notRead: 'Encara sense llegir',
      notReadBody: 'Ningú no ha demanat que es llegeixi. Un model llegint seixanta pàgines costa diners, així que no passa sol.',
      notReadHint: 'En llegir-lo sortiran les xifres, els riscos i les oportunitats, cadascuna amb la frase d\'on va sortir.',
      summary: 'Resum',
      figures: 'Xifres',
      colFigure: 'Què mesura',
      colValue: 'Valor',
      colPeriod: 'Període',
      accept: 'Portar a una sèrie',
      accepted: 'A la sèrie',
      risks: 'Riscos',
      opportunities: 'Oportunitats',
      predictions: 'Previsions',
      about: 'Fitxa',
      source: 'Font',
      noSource: 'Sense font',
      published: 'Publicat',
      filed: 'Arxivat',
      confidence: 'Confiança',
      corroborations: 'El mateix, dit per altres',
      mentions: 'Matèries primeres esmentades',
    },

    accept: {
      title: 'Portar la xifra a una sèrie',
      figure: 'Xifra',
      period: 'Període',
      into: 'A quin indicador',
      intoHint: 'Es desarà com una lectura més d\'aquella sèrie, amb l\'informe com a origen.',
      pick: 'Tria un indicador',
      confirm: 'Desar a la sèrie',
      done: 'Desat a la sèrie',
    },

    topics: {
      title: 'Temes',
      subtitle: 'El que heu decidit vigilar',
      new: 'Nou tema',
      edit: 'Editar tema',
      colName: 'Tema',
      colKind: 'Categoria',
      colImportance: 'Importància',
      colContents: 'Contingut',
      colOwner: 'Responsable',
      contents: '{sources} fonts · {indicators} indicadors',
      noOwner: 'Sense responsable',
      empty: 'Encara no hi ha temes',
      emptyHint: 'Un tema agrupa fonts, indicadors i informes. Comença pels tres o quatre que de debò us afecten.',
      name: 'Nom',
      namePlaceholder: 'Acer, Construcció Espanya, Automatització…',
      description: 'Descripció',
      kind: 'Categoria',
      importance: 'Importància',
      owner: 'Responsable',
      ownerHint: 'Un tema sense responsable és un tema que ningú no actualitza.',
      archive: 'Arxivar',
      restore: 'Retornar a les llistes',
      restored: 'Tema retornat a les llistes',
      showArchived: 'Veure arxivats',
      archiveConfirm: 'Arxivar aquest tema?',
      archiveConfirmHint: 'El que en penjava es queda on és i torna a aparèixer si el recupereu.',
    },

    sources: {
      title: 'Fonts',
      subtitle: 'D\'on surten les xifres, i de qui és la paraula',
      new: 'Nova font',
      edit: 'Editar font',
      tiersTitle: 'Què vol dir cada nivell',
      searchPlaceholder: 'Nom o adreça…',
      allTiers: 'Tots els nivells',
      colName: 'Font',
      colTier: 'Nivell',
      colKind: 'Tipus',
      colChecked: 'Última revisió',
      overdue: '{count} dies',
      foundSomething: 'Hi havia alguna cosa',
      nothingNew: 'Res de nou',
      empty: 'Encara no hi ha fonts',
      emptyHint: 'Comença per les tres o quatre que ja llegiu cada mes.',
      name: 'Nom',
      namePlaceholder: 'INE · Índex de preus industrials',
      url: 'Adreça',
      urlPlaceholder: 'https://…',
      kind: 'Tipus',
      tier: 'Nivell de fiabilitat',
      frequency: 'Cada quants dies revisar-la',
      frequencyHint: 'Zero vol dir «quan arribi alguna cosa»: un butlletí no té calendari.',
      country: 'País',
      countryPlaceholder: 'ES',
      notes: 'Notes',
      archive: 'Arxivar',
      restore: 'Retornar a les llistes',
      restored: 'Font retornada a les llistes',
      showArchived: 'Veure arxivats',
      archiveConfirm: 'Arxivar aquesta font?',
      archiveConfirmHint: 'Els indicadors i els informes que l\'anomenen la continuen anomenant.',
    },

    alerts: {
      title: 'Alertes',
      subtitle: 'Què mereix interrompre algú',
      new: 'Nova alerta',
      edit: 'Editar alerta',
      quietTitle: 'Com s\'evita el soroll',
      quietBody: 'Una regla avisa UNA vegada per cada moviment, no una vegada per nit. Després calla els dies que li diguis, fins i tot sobre un altre assumpte: vint avisos pel mateix són vint avisos que ningú no llegeix.',
      colName: 'Alerta',
      colKind: 'Vigila',
      colWho: 'Avisa',
      colLast: 'Últim avís',
      colState: 'Estat',
      neverFired: 'No ha saltat mai',
      on: 'Activa',
      off: 'Aturada',
      empty: 'Encara no hi ha alertes',
      emptyHint: 'Sense alertes el mòdul funciona igual: cal entrar a mirar-lo.',
      name: 'Nom',
      namePlaceholder: 'El coure puja més d\'un 5 %',
      kind: 'Què vigila',
      indicator: 'Indicador',
      indicatorHint: 'Buit els vigila tots.',
      indicatorSupplierHint: 'L\'índex contra el qual es compara el proveïdor. En cal un.',
      anyIndicator: 'Qualsevol',
      thresholdPct: 'A partir de quin percentatge',
      thresholdEur: 'A partir de quants euros a l\'any',
      window: 'En quants dies',
      severity: 'Gravetat',
      quiet: 'Dies de silenci',
      quietHint: 'Després d\'avisar, calla aquest temps.',
      who: 'A quins rols avisa',
      whoHint: 'Rols, no persones: una alerta adreçada a algú deixa de funcionar la setmana que marxa.',
      whoPlaceholder: 'admin, manager',
      active: 'Activa',
      removeConfirm: 'Treure aquesta alerta?',
      removeConfirmHint: 'Deixa d\'avisar. El que ja va avisar es queda a les notificacions.',
      sentence: {
        price: 'Quan un indicador es mogui més d\'un {threshold} % en {days} dies. Silenci de {quiet} dies.',
        exposure: 'Quan un impacte obert passi de {threshold} € a l\'any. Silenci de {quiet} dies.',
        supplier: 'Quan un proveïdor pugi més de {threshold} punts per sobre del seu índex. Silenci de {quiet} dies.',
        report: 'Quan arribi un informe nou sobre el tema, mirant els últims {days} dies. Silenci de {quiet} dies.',
        trend: 'Quan un indicador canviï de direcció amb més d\'un {threshold} %. Silenci de {quiet} dies.',
      },
    },

    alertKinds: {
      price: 'Un preu',
      priceHint: 'Salta quan un indicador es mou més del que diguis en la finestra que diguis.',
      exposure: 'El que costa',
      exposureHint: 'Salta pels diners, no pel percentatge: un 2 % sobre la compra principal és més que un 12 % sobre una cosa que compreu dues vegades l\'any.',
      supplier: 'Un proveïdor',
      supplierHint: 'Salta quan un proveïdor puja per sobre de l\'índex amb què se\'l compara. Necessita aquell índex enllaçat.',
      report: 'Un informe nou',
      reportHint: 'Salta quan apareix alguna cosa nova sobre un tema.',
      trend: 'Un canvi de tendència',
      trendHint: 'Salta quan el mes i l\'any deixen d\'anar en la mateixa direcció.',
    },

    decisions: {
      title: 'Decisions',
      subtitle: 'Què es va decidir, i si va sortir bé',
      new: 'Registrar decisió',
      allKinds: 'Totes',
      onlyPending: 'Només les que toca valorar',
      colWhat: 'Decisió',
      colKind: 'Tipus',
      colWhen: 'Data',
      colOutcome: 'Resultat',
      reviewed: 'Valorada',
      dueNow: 'Toca valorar-la',
      noReview: 'Sense data de revisió',
      empty: 'Encara no hi ha decisions',
      emptyHint: 'Quan direcció decideixi alguna cosa a partir d\'aquestes dades, apunta-ho aquí: és l\'única manera de saber després si va funcionar.',
      about: 'Sobre {name} {change} · {amount} a l\'any',
      what: 'Què es decideix',
      whatPlaceholder: 'Pujar la tarifa d\'estructura un 4 %',
      kind: 'Tipus',
      reason: 'Per què',
      reasonHint: 'El que se sabia aquell dia. D\'aquí a un any això és el que es llegeix.',
      expected: 'Què s\'espera que passi',
      expectedHint: 'Contra això es valorarà després.',
      reviewAt: 'Quan tornar-hi',
      reviewAtHint: 'Sense data, ningú no hi torna.',
      willClose: 'Registrar la decisió tanca també l\'impacte que la va motivar.',
      record: 'Registrar',
      recorded: 'Decisió registrada',
    },

    decisionKinds: {
      update_prices: 'Actualitzar tarifes',
      negotiate_supplier: 'Negociar amb el proveïdor',
      buy_ahead: 'Comprar per avançat',
      change_material: 'Canviar de material',
      review_quotes: 'Revisar pressupostos',
      hold_prices: 'Mantenir preus',
      raise_minimum: 'Pujar el mínim d\'estoc',
      hedge: 'Cobrir-se',
      other: 'Una altra',
    },

    decision: {
      subtitle: '{kind} · {when}',
      why: 'Per què es va decidir',
      noReason: 'No es va escriure el motiu.',
      expected: 'Què s\'esperava',
      outcome: 'Com va sortir',
      noOutcome: 'Encara no s\'ha valorat.',
      howItWent: 'Què va passar de veritat',
      howItWentHint: 'Amb números si n\'hi ha. És el que permet saber si el mòdul serveix.',
      recordOutcome: 'Desar el resultat',
      outcomeRecorded: 'Resultat desat',
      basedOn: 'Amb què es va decidir',
      about: 'Fitxa',
      kind: 'Tipus',
      decidedAt: 'Data',
      decidedBy: 'Qui',
      reviewAt: 'Revisió',
      openImpact: 'Veure l\'impacte',
    },

    briefing: {
      title: 'Informe de direcció',
      subtitle: 'El que ha passat, el que costa i què revisar',
      weekly: 'Informe setmanal',
      meeting: 'Briefing de reunió',
      write: 'Redactar amb IA',
      unavailable: 'La redacció no està disponible. Les xifres de sota són l\'informe igualment.',
      forDirection: 'Per a direcció',
      situation: 'Situació',
      risks: 'Riscos',
      opportunities: 'Oportunitats',
      suppliers: 'Proveïdors',
      actions: 'Què fer aquesta setmana',
      noProse: 'Sense redacció',
      noProseBody: 'El model no ha pogut redactar. Les xifres són completes a sota.',
      risksCount: 'Riscos oberts',
      opportunitiesCount: 'Oportunitats',
      exposure: 'Compra exposada',
      costAtRisk: 'Sobrecost anual',
      committed: 'Compromès a proveïdors',
      commodities: 'Matèries primeres',
      economy: 'Economia i sector',
      openRisks: 'Riscos oberts',
      colWhat: 'Què',
      colChange: 'Variació',
      colCost: 'A l\'any',
      colReferences: 'Referències',
      gaps: 'Què no cobreix aquest informe',
      gapUnlinked: '{count} indicadors no estan lligats a res vostre: es vigilen, però no produeixen cap xifra en euros.',
      gapStale: '{count} indicadors fa temps que no s\'actualitzen.',
      gapCatalogue: 'No hi ha catàleg de materials emmirallat: sense Magatzem no es pot convertir un moviment de preu en euros.',
      gapQuotes: {
        not_available: 'El marge dels pressupostos oberts no hi entra: els costos d\'un pressupost no acceptat no surten del mòdul de Pressupostos, així que aquest no els coneix.',
        module_absent: 'El marge dels pressupostos oberts no hi entra: Pressupostos no està instal·lat.',
      },
    },

    chart: {
      title: 'Sèrie',
      empty: 'Sense prou dades',
      notZeroed: 'L\'eix no comença a zero',
    },

    related: {
      material: 'Mercat',
      supplier: 'Preus i mercat',
    },

    dashboard: {
      risks: 'Riscos de mercat',
      risksHelp: 'Quants moviments de fora estan costant diners ara mateix.',
      costAtRisk: 'Sobrecost anual',
      costAtRiskHelp: 'El que els moviments oberts afegeixen al cost d\'un any, a consum actual.',
      opportunities: 'Oportunitats',
      opportunitiesHelp: 'Quants moviments de fora van a favor: matèries primeres o energia a la baixa.',
      exposure: 'Compra exposada',
      exposureHelp: 'La compra anual que passa per les referències afectades per alguna cosa que s\'ha mogut.',
      watched: 'Factors vigilats',
      watchedHelp: 'Quants indicadors hi ha al radar. Avisa en ambre si algun fa temps que no s\'actualitza.',
      moved: 'El que es mou',
      movedHelp: 'Els factors fora del normal, amb la seva variació. Estira la targeta i n\'hi caben més.',
      reports: 'Informes nous',
      reportsHelp: 'El que ha arribat les dues últimes setmanes, amb el nivell de la seva font.',
    },

    notifications: {
      category: 'Mercats',
      price: {
        title: 'Moviment a {indicator}',
        body: '{indicator} s\'ha mogut un {change} % en {days} dies.',
      },
      trend: {
        title: 'Canvi de tendència a {indicator}',
        body: '{indicator} va al {change} % en el mes i al {year} % en l\'any: ha canviat de direcció.',
      },
      exposure: {
        title: 'Sobrecost per {indicator}',
        body: '{indicator} afegeix uns {cost} € a l\'any, sobre {materials} referències.',
      },
      supplier: {
        title: '{supplier} puja per sobre del mercat',
        body: '{supplier} va {deviation} punts per sobre de {indicator}.',
      },
      report: {
        title: 'Informes nous',
        body: 'Han arribat {count} informes. L\'últim: {title}.',
      },
      weekly: {
        title: 'Informe de mercat',
        body: '{risks} riscos i {opportunities} oportunitats. Sobrecost anual estimat: {cost} €.',
      },
    },

    jobs: {
      assess: 'Recalcular el mercat i avaluar les alertes',
      briefing: 'Informe setmanal de mercat',
    },

    assistant: {
      recordingDecision: 'Registrant la decisió',
    },
  },

  permissions: {
    markets: {
      read: 'Veure el mercat: radar, indicadors, informes i fonts',
      exposure: 'Veure el que el mercat ens costa, en euros',
      write: 'Mantenir indicadors, sèries, enllaços, fonts i informes',
      decide: 'Registrar decisions, tancar impactes i configurar alertes',
    },
  },

  settings: {
    ns: {
      markets: {
        title: 'Mercats',
        subtitle: 'Què es considera molt en aquesta empresa',
        watchThreshold: {
          label: 'Moviment que mereix mirar-se (%, en 30 dies)',
          help: 'Per sota d\'això un moviment és soroll i no es registra res. Cada indicador pot portar el seu; aquest és el de la resta.',
        },
        alertThreshold: {
          label: 'Moviment que es considera molt (%, en 30 dies)',
          help: 'A partir d\'aquí el radar el pinta com a risc i puja la gravetat del que costa.',
        },
        impactFloor: {
          label: 'Cost anual mínim per registrar un impacte (€)',
          help: 'Un moviment que costa menys d\'això a l\'any és cert i no és notícia. Sense aquest terra, la llista del que necessita atenció s\'omple de files sobre les quals ningú no actuarà.',
        },
        highCost: {
          label: 'Cost anual que fa important un impacte (€)',
          help: 'El que separa alguna cosa que cal vigilar d\'alguna cosa que es porta a una reunió.',
        },
        criticalCost: {
          label: 'Cost anual que fa crític un impacte (€)',
          help: 'Per sobre d\'això es marca com a crític i qui sigui a l\'alerta se n\'assabenta.',
        },
        weeklyBriefing: {
          label: 'Enviar l\'informe de mercat els dilluns',
          help: 'Un resum del que s\'ha mogut, el que costa i què mirar. Desactiva\'l si preferiu entrar a la pantalla.',
        },
      },
    },
  },

  audit: {
    actions: {
      markets: {
        topic_created: 'Tema creat',
        topic_updated: 'Tema modificat',
        topic_archived: 'Tema arxivat',
        topic_restored: 'Tema retornat a les llistes',
        source_created: 'Font creada',
        source_updated: 'Font modificada',
        source_checked: 'Font revisada',
        source_archived: 'Font arxivada',
        source_restored: 'Font retornada a les llistes',
        indicator_created: 'Indicador creat',
        indicator_updated: 'Indicador modificat',
        indicator_archived: 'Indicador arxivat',
        indicator_restored: 'Indicador retornat a les llistes',
        point_recorded: 'Lectura registrada',
        point_removed: 'Lectura treta',
        series_imported: 'Sèrie importada',
        link_created: 'Enllaç creat',
        link_updated: 'Enllaç modificat',
        link_removed: 'Enllaç tret',
        links_suggested: 'Enllaços proposats per IA acceptats',
        report_filed: 'Informe arxivat',
        report_updated: 'Informe modificat',
        report_archived: 'Informe retirat',
        impact_reviewed: 'Impacte revisat',
        impact_dismissed: 'Impacte descartat',
        alert_created: 'Alerta creada',
        alert_updated: 'Alerta modificada',
        alert_removed: 'Alerta treta',
        decision_recorded: 'Decisió registrada',
        decision_updated: 'Decisió modificada',
        decision_reviewed: 'Resultat de la decisió registrat',
      },
    },
  },

  assistant: {
    openers: {
      markets: {
        'whats-changed': 'Què ha canviat que ens pugui afectar?',
        'biggest-risk': 'Quin és ara mateix el nostre risc de mercat més gran?',
        'supplier-above-market': 'Hi ha algun proveïdor pujant per sobre del mercat?',
        simulate: 'Quant ens costaria una altra pujada de la nostra matèria primera principal?',
      },
    },
  },
}
